export const compactThumbnailClasses = {
  container: 'group mb-2 flex flex-1 cursor-pointer select-none flex-col px-2 outline-none',
  image: 'flex h-20 flex-1 items-center justify-center overflow-hidden rounded-md bg-black text-sm text-white',
};

export function compactThumbnailCaption(
  seriesNumber: string | number,
  description: string
): string {
  return `S${seriesNumber} · ${description}`;
}

export function shouldShowInstanceCount(numInstances: number): boolean {
  return numInstances > 1;
}
